import { render, staticRenderFns } from "./batchTransfer.vue?vue&type=template&id=67a5d866&scoped=true&"
import script from "./batchTransfer.vue?vue&type=script&lang=js&"
export * from "./batchTransfer.vue?vue&type=script&lang=js&"
import style0 from "./batchTransfer.vue?vue&type=style&index=0&id=67a5d866&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a5d866",
  null
  
)

export default component.exports